import { QueryHookOptions, useQuery } from '@apollo/client';
import { DocumentNode } from 'graphql';
import { useMemo } from 'react';
import { IQueryWithPagination } from 'types/common';
import { getGraphQLQueryName } from 'utils';

import { WithKey } from './useInfiniteDataQuery';

export function useSingleDataQuery<T = any>(graphQLQuery: DocumentNode, queryProps?: QueryHookOptions) {
  const queryName = getGraphQLQueryName(graphQLQuery) || '';
  const queryResultProps = useQuery<WithKey<typeof queryName, T>>(graphQLQuery, {
    // fetchPolicy: 'cache-and-network',
    // nextFetchPolicy: 'cache-first',
    ...queryProps,
    notifyOnNetworkStatusChange: false,
  });
  const content = useMemo(() => queryResultProps.data?.[queryName], [queryResultProps.data?.[queryName]]);

  return { ...queryResultProps, content };
}

export function useManyDataQuery<T = any>(graphQLQuery: DocumentNode, queryProps?: QueryHookOptions) {
  const queryName = getGraphQLQueryName(graphQLQuery) || '';
  const queryResultProps = useQuery<WithKey<typeof queryName, IQueryWithPagination<T[]>>>(graphQLQuery, {
    fetchPolicy: 'cache-and-network',
    // nextFetchPolicy: 'cache-first',
    ...queryProps,
    notifyOnNetworkStatusChange: true,
    variables: {
      ...queryProps?.variables,
      pagination: {
        page: 1,
        ...(queryProps?.variables?.pagination || {}),
      },
    },
  });

  return {
    ...queryResultProps,
    content: queryResultProps.data?.[queryName]?.data || [],
    meta: queryResultProps.data?.[queryName]?.meta,
  };
}
